import { AuthContext } from "contexts/auth";
import { TaskContext } from "contexts/task";
import { useRouter } from "next/router";
import { useContext, useEffect } from "react";

import { ApplyFilter } from "@/types/owner/task/applyFilter";
import clsx from "clsx";
import styles from "./index.module.scss";

type Props = {
  isDisabled?: boolean;
  setApplyFilter?: React.Dispatch<React.SetStateAction<ApplyFilter>>;
  resetSelect?: () => void;
};

const OwnerTaskTab: React.FC<Props> = ({
  isDisabled,
  setApplyFilter,
  resetSelect = () => {}
}) => {
  const router = useRouter();
  const { setOwnerFilterList } = useContext(TaskContext);
  const { summaryAccounts } = useContext(AuthContext);
  const { tab } = router.query;

  //アクティブなタブを復元
  useEffect(() => {
    if (tab) {
      const tabName = tab as string;
      setOwnerFilterList((state: any) => ({
        ...state,
        tab: tabName,
        statusId:
          tabName === "waiting"
            ? [1]
            : tabName === "task" || tabName === "suggestion"
              ? state.statusId.length > 0
                ? state.statusId //ダッシュボードから遷移した際のstatusIdを保持
                : [3, 4, 5]
              : []
      }));
    }
  }, [tab]);

  return (
    <div
      className={
        summaryAccounts.account_type === "normal"
          ? styles.tab_container
          : styles.tab_container_summary
      }
    >
      <div
        className={clsx(
          styles.tab,
          "select-none",
          router.pathname === "/owner/contract" && styles.tab__active
        )}
        onClick={() => {
          if (!isDisabled) {
            // 一括選択モードを解除
            resetSelect();
            setOwnerFilterList((state: any) => ({
              ...state,
              tab: "contract",
              page: 1
            }));
            if (setApplyFilter) setApplyFilter(null);
            router.push("/owner/contract");
          }
        }}
      >
        物件/仕事
      </div>

      <div
        className={clsx(
          styles.tab,
          "select-none",
          tab === "waiting" && styles.tab__active
        )}
        onClick={() => {
          if (!isDisabled) {
            // 一括選択モードを解除
            resetSelect();
            setOwnerFilterList((state: any) => ({
              ...state,
              statusId: [1],
              scheduledMonth: [],
              tab: "waiting",
              suggestion: "なし",
              problem: false, //異常ありフィルタはないので解除
              page: 1
            }));

            if (setApplyFilter) setApplyFilter("tabChange");
            router.push("/owner/task?tab=waiting");
          }
        }}
      >
        予定
      </div>

      <div
        className={clsx(
          styles.tab,
          "select-none",
          tab === "task" && styles.tab__active
        )}
        onClick={() => {
          if (!isDisabled) {
            setOwnerFilterList((state: any) => ({
              ...state,
              statusId: [3, 4, 5],
              scheduledMonth: [],
              tab: "task",
              suggestion: "", //不要？
              rejectedOnly: 0,
              pastDue: "",
              page: 1
            }));

            if (setApplyFilter) setApplyFilter("tabChange");
            router.push("/owner/task?tab=task");
          }
        }}
      >
        報告
      </div>

      <div
        className={clsx(
          styles.tab,
          "select-none",
          tab === "suggestion" && styles.tab__active
        )}
        onClick={() => {
          if (!isDisabled) {
            // 一括選択モードを解除
            resetSelect();
            setOwnerFilterList((state: any) => ({
              ...state,
              statusId: [],
              scheduledMonth: [],
              taskcategory_id: [],
              tab: "suggestion",
              suggestion: "", //不要？
              rejectedOnly: 0,
              pastDue: "",
              page: 1
            }));

            if (setApplyFilter) setApplyFilter("tabChange");
            router.push("/owner/task?tab=suggestion");
          }
        }}
      >
        提案
      </div>
    </div>
  );
};

export default OwnerTaskTab;
